/**
 * Pedestal Health brand palette — the single source of truth for the
 * named brand swatches. ``muiTheme.ts`` maps these into MUI's semantic
 * palette slots (primary/secondary/success/warning/error/info/…) so
 * application code keeps referencing the semantic slots rather than
 * hex literals. Reach for these named tokens directly only when an
 * intent doesn't fit cleanly into a semantic slot (e.g. an accent
 * dot, a chart series color).
 *
 * Grouped to match the brand-guide swatch sheet:
 * - Primary Blues:    pedestalBlue, aqua, ocean, azure, navy
 * - Supporting Shades: white, pearl, silver, graphite, black
 * - Secondary Colors: lime, citron, forest, rose, orange, crimson
 */
export const brand = {
  // ── Primary Blues ────────────────────────────────────────────
  pedestalBlue: "#73F0E9",
  aqua: "#0FB5D2",
  ocean: "#0888A8",
  azure: "#4166FF",
  navy: "#140298",

  // ── Supporting Shades ───────────────────────────────────────
  white: "#FFFFFF",
  pearl: "#F0F0F0",
  silver: "#ADADAD",
  graphite: "#575757",
  black: "#000000",

  // ── Secondary Colors ────────────────────────────────────────
  lime: "#E0FF45",
  citron: "#C6DB0A",
  forest: "#495102",
  rose: "#F16CB9",
  orange: "#FD8524",
  crimson: "#A5052D",
} as const;

export type BrandColor = (typeof brand)[keyof typeof brand];
